export const HelperDeliveryType = [
    'SMS',
    'Voice',
];
export const OTPStatus = [
    'Offered',
    'Pass',
    'Fail',
    'Ineligible',
    'InProgress',
    'MaxRetryHit',
    'Abandoned',
    'NotConfigured',
];
export const KBAStatus = [
    'Offered',
    'MultiPassOffered',
    'Ineligible',
    'NoData',
    'Passed',
    'Failed',
    'Abandoned',
];
export interface OTPResponse {
    AuthURL: string;
    DeliveryType: number;
    Language: number;
    Passcode: string;
    Status: number;
    Timestamp: Date;
}

export interface Choice {
    Answer: boolean;
    ChoiceText: string;
    Id: number;
}

interface MultiPassQuestion {
    Choices: Choice[];
    Id: number;
    QuestionText: string;
}

interface Question {
    Choices: Choice[];
    Id: number;
    QuestionText: string;
}

export interface KBAResponse {
    AnswerUrl: string;
    MultiPassQuestions: MultiPassQuestion[];
    MultiPassStatus: number;
    Questions: Question[];
    Status: number;
    Timestamp: Date;
}

export interface DocumentAuthentication {
    Id: string;
    Url?: any;
    Timestamp: Date;
    Status: number;
}

export interface Authentication {
    Id: string;
    KBA: KBAResponse;
    OTP: OTPResponse;
    Timestamp: Date;
    DocumentAuthentication: DocumentAuthentication;
}
